import { useEffect, useCallback } from 'react';
import { PostMessage } from '../../../message-service';
import { globalConfig } from '../../../shared/config/config';

function IsJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

// able actions to post from outside
const actions = [
  globalConfig.postMessage.actions.openPopup,
  globalConfig.postMessage.actions.openPublicPost,
  globalConfig.postMessage.actions.openReview,
  globalConfig.postMessage.actions.editorPersonalizationChanged,
  globalConfig.postMessage.actions.editorClosedPopup,
  globalConfig.postMessage.actions.updatePopupData,
  globalConfig.postMessage.actions.changePostPopup,
  globalConfig.postMessage.actions.tintAnalyticsScriptLoaded,
  globalConfig.postMessage.actions.hidePopup,
];

const usePostMessageListener = (callback: (data: PostMessage) => void) => {
  const memoizedOnReceiveMessage = useCallback(
    (event: MessageEvent) => {
      if (IsJsonString(event.data) && event.data.indexOf(globalConfig.postMessage.actions.openPopup) !== -1) {
        const data = JSON.parse(event.data);
        if (callback) {
          callback(data);
        }
      }

      if (event.data && actions.includes(event.data.type)) {
        if (callback) {
          callback(event.data);
        }
      }
    },
    [callback]
  );

  useEffect(() => {
    window.addEventListener('message', memoizedOnReceiveMessage, false);
    return () => {
      window.removeEventListener('message', memoizedOnReceiveMessage, false);
    };
  }, [memoizedOnReceiveMessage]);
};

export default usePostMessageListener;
